import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { setFootprintingFarmResourceConsumption, setFootprintingFarmResourceConsumptionAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_FARM, FOOTPRINTING_FARM_PRIMARY_DATA_ADMIN, FOOTPRINTING_FARM_RESOURCE_CONSUMPTION } from "consts";

import { FootprintingFarmResourceConsumption } from "models";

export const useMutateFootprintingFarmResourceConsumption = (
  farmId: string,
  year: number,
  payload: FootprintingFarmResourceConsumption,
  primaryDataId?: string
) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? setFootprintingFarmResourceConsumptionAdmin : setFootprintingFarmResourceConsumption;

  return useMutation(
    {
      mutationKey: [FOOTPRINTING_FARM_RESOURCE_CONSUMPTION],
      mutationFn: () => queryFn(payload, primaryDataId),
      retry: (_, error) => {
        if (!(error instanceof AxiosError)) return true;

        if (error.response?.status === 404 || error.response?.status === 418) return false;
        return true;
      },
      onSuccess: async () => {
        const QKs = [
          [FOOTPRINTING_FARM_RESOURCE_CONSUMPTION, primaryDataId],
          [FOOTPRINTING_FARM_PRIMARY_DATA_ADMIN, primaryDataId],
          [FOOTPRINTING_FARM, farmId, year],
          [FOOTPRINTING_FARM, primaryDataId, isAdmin],
        ];
        await Promise.all(QKs.map((QK) => queryClient.invalidateQueries({ queryKey: QK })));
        await Promise.all(QKs.map((QK) => queryClient.refetchQueries({ queryKey: QK })));
      },
    },
    queryClient
  );
};
